import React, { useState } from 'react'
import Flex from 'typescript-styled-flex'
import { FiChevronRight } from 'react-icons/fi'
import { Divider } from '@material-ui/core'
import { Color } from '../../../../../../components/ColorPalette'
import styled, { ITheme, theme } from '../../../../../../theme'
import { IWithSize } from '../../../../../BookingCalendar/Calendar/Calendar'
import useSize from '../../../../../../hooks/useSize'
import { useDispatch } from 'react-redux'
import { PopoveredIcon2 } from '../../../../../../components/PopoveredIcon/PopoveredIcon'

export const ItemBadge = styled.div<
  { empty?: boolean; disabled?: boolean } & IWithSize
>`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  text-align: center;
  width: ${({ size }) => (size ? 20 * size : 20)}px;
  height: ${({ size }) => (size ? 17 * size : 17)}px;
  border-radius: 3px;
  font-size: ${({ size }) => (size ? 12 * size : 12)}px;
  letter-spacing: 0.12px;
  margin-right: ${({ size }) => (size ? 20 * size : 20)}px;
  color: ${(props: ITheme & { empty?: boolean; disabled?: boolean }) =>
    props.disabled
      ? 'white'
      : props.empty
      ? props.theme.colors.palette.darkGreyTwo
      : 'white'};
  background-color: ${(
    props: ITheme & { empty?: boolean; disabled?: boolean },
  ) =>
    props.disabled
      ? props.theme.colors.palette.whiteTwo
      : props.empty
      ? props.theme.colors.palette.pinkishGrey
      : props.theme.colors.palette.emerald};
`

const Label = styled.div<{ empty?: boolean; disabled?: boolean }>`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.16px;
  user-select: none;
  margin-left: 12px;
  color: ${(props: ITheme & { empty?: boolean; disabled?: boolean }) =>
    props.empty
      ? props.theme.colors.palette.slateGrey
      : props.theme.colors.palette.darkGreyTwo};
`

function NotificationItem({
  icon,
  label,
  count,
  onClick,
  disabled = false,
}: INotificationItem) {
  const empty = count === '0'
  const size = useSize('settings')
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const dispatch = useDispatch()

  const handlePopoverOpen = event => {
    const div = document.createElement('div')
    div.style.position = 'fixed'
    div.style.top = `${event.clientY + 20}px`
    div.style.left = `${event.clientX}px`
    div.style.width = '1px'
    div.style.height = '1px'
    document.body.appendChild(div)
    event.preventDefault()
    event.stopPropagation()
    setPopoverAnchor(div)
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    dispatch({
      type: 'toggle left sidebar',
      isSidebarOpen: false,
      isSidebarBlock: false,
    })
    setPopoverAnchor(null)
  }

  return (
    <>
      <Flex
        onClick={onClick ? onClick : handlePopoverOpen}
        full={true}
        alignCenter={true}
        style={{
          cursor: 'pointer',
          height: '68px',
          minHeight: '68px',
          padding: '0 20px 0 10px',
        }}
      >
        <Flex full={true} alignCenter={true}>
          <Color
            width={'28px'}
            height={'28px'}
            color={
              disabled
                ? theme.colors.palette.whiteTwo
                : empty
                ? theme.colors.palette.slateGrey
                : theme.colors.palette.emerald
            }
            style={{
              maxHeight: '28px',
              maxWidth: '28px',
              minHeight: '28px',
              minWidth: '28px',
            }}
          >
            {icon}
          </Color>
          <Label empty={empty}>{label}</Label>
        </Flex>
        <Flex alignCenter={true}>
          <ItemBadge size={size} empty={empty} disabled={disabled}>
            {count}
          </ItemBadge>
          {disabled && (
            <PopoveredIcon2
              anchorEl={popoverAnchor}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
            />
          )}
          {!disabled && <FiChevronRight />}
        </Flex>
      </Flex>
      <Divider style={{ width: '100%' }} />
    </>
  )
}

export default NotificationItem

export interface INotificationItem {
  icon: React.ReactNode | JSX.Element
  label: string
  count: string
  disabled?: boolean
  onClick?: () => void
}
